import React, { useState } from "react";
import Header from "../components/header";
import Footer from '../components/footer';
import FloatingChatButton from '../components/FloatingChatButton';
import ContactForm from "../components/ContactForm";
import CallbackPopup from "../components/CallbackPopup";
import { RiMapPinFill } from "react-icons/ri";
import StarDoctorsIndia from "../components/StarDoctorsIndia";
import TopHospitalsIndia from "../components/TopHospitalsIndia";
import IndiaBlogsCarousel from "../components/IndiaBlogsCarousel";
import { useNavigate } from 'react-router-dom';

const IndiaMedicalPage = () => {
  const navigate = useNavigate();
  const [isCallbackOpen, setIsCallbackOpen] = useState(false);
  return (
    <div className="bg-white">
      {/* Header */}
      {/* Replace with your actual header component */}
      <Header />
      {/* Country Banner */}
      <section className="w-full">
        <img
          src="/images/india1.webp"
          alt="India Banner"
          className="w-full h-auto"
        />
      </section>
      {/* Indian Culture Info */}
      <section className="py-20 mt-20">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row gap-8 items-center">
            {/* Image on Left */}
            <div className="md:w-1/2">
              <img
                src="/images/india2.webp"
                alt="Indian Culture"
                className="w-full h-auto rounded"
              />
            </div>

            {/* Text on Right */}
            <div className="md:w-1/2 md:pl-12 ml-6">
              <h4 className="text-3xl font-bold mb-6 text-gray-800">
                Information on the Indian Culture
              </h4>

              <p className="text-[18px] text-gray-700 leading-relaxed mb-6">
                India is a vibrant land of rich cultural heritage, where ancient
                traditions seamlessly blend with modernity. As you travel,
                you'll experience the warmth of Indian hospitality, where
                holistic wellness is deeply rooted in the culture. Renowned
                hospitals combine world-class medical expertise with
                compassionate care, ensuring not just physical healing but also
                a soulful journey.
              </p>

              <ul className="grid grid-cols-2 gap-y-4 gap-x-10 list-disc pl-6 text-[18px] text-gray-800 leading-relaxed marker:text-blue-600 marker:text-2xl">
                <li>Welcoming People</li>
                <li>Vibrant Culture</li>
                <li>Top Medical Destination</li>
                <li>Last Mile Assistance</li>
              </ul>

              <div className="flex gap-4 mt-10">
                <a
                  href="https://wa.me/9599222655"
                  className="bg-blue-200 text-blue-800 px-4 py-2 rounded"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Learn More
                </a>
                <button 
                  className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
                  onClick={() => setIsCallbackOpen(true)}
                >
                  Get a call back
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Indian Cities */}
      <section className="py-10 mt-10 bg-gray-50">
        <div className="container mx-auto px-4 text-center">
          <h3 className="text-5xl font-bold">
            <span className="text-blue-600">Indian</span> Cities
          </h3>
          <p className="mt-3 text-2xl">
            These Indian cities are known for multiple leading treatments and
            medical services.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-8">
            {[
              "Delhi NCR",
              "Bangalore",
              "Chennai",
              "Mumbai",
              "Ahmedabad",
              "Hyderabad",
              "Pune",
              "Jaipur",
            ].map((city) => (
              <div
                key={city}
                className="bg-white border p-6 shadow text-center rounded-2xl flex flex-col justify-center items-center h-60"
              >
                <RiMapPinFill className="text-blue-600 text-3xl mb-2" />
                <h5 className="font-semibold text-lg">{city}</h5>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Treatments */}
      <section className="py-10">
        <div className="container mx-auto px-4">
          <div className="flex flex-col-reverse md:flex-row gap-8 items-center">
            <div className="md:w-1/2">
              <h2 className="text-4xl font-bold mb-8">
                India is a leading country in the following treatments
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-8 mt-10">
                {[
                  "Cardiology",
                  "Oncology",
                  "Pulmonology",
                  "Organ Transplant",
                  "Orthopaedics",
                  "Dermatology",
                ].map((treatment) => (
                  <div key={treatment} className="flex flex-col">
                    <div className="flex items-center mb-2">
                      <div className="w-3 h-3 bg-blue-600 rounded-full mr-3"></div>
                      <h3 className="text-lg font-semibold text-gray-800">
                        {treatment}
                      </h3>
                    </div>
                    <a
                      href="/speciality/cardiology"
                      className="text-blue-600 text-sm hover:text-blue-800 hover:underline transition-colors ml-6"
                    >
                      Learn More
                    </a>
                  </div>
                ))}
              </div>
            </div>
            <div className="md:w-1/2">
              <img
                src="/images/india3.webp"
                alt="India Treatments"
                className="w-full h-auto rounded"
              />
            </div>
          </div>
        </div>
      </section>
      {/* Contact Form Placeholder */}
      <section className="py-10 bg-gray-50">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold">
            Searching for a treatment in India?
          </h2>
          <p className="mb-6">
            Fill the form to get a call back from our support team
          </p>
          {/* Replace with actual form */}
          <div className=" mx-auto">
            <ContactForm formType="india-medical" />
          </div>
        </div>
      </section>
      <TopHospitalsIndia />
      <StarDoctorsIndia />

      <section className="py-16 bg-white tourismLeisureSec">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <p className="font-semibold text-lg">Tourism & Leisure</p>
            <h3 className="text-3xl md:text-4xl font-bold mt-2">
              <span className="text-[#1976f2]">Things to do</span> in India
            </h3>
            <p className="mt-3 text-gray-600">
              India is a country of colours and festivals, it has all the
              seasons <br className="hidden md:block" />
              and geographies to make it a fulfilling tourism spot.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                title: "Festivals",
                desc: "Indian is a land of festivals comprising more than 51 festivals taking place throughout the year.",
              },
              {
                title: "Natural Rejoice",
                desc: "The country spans diverse geographies, flora & fauna, rewarding tourists with plenty of natural retreat options.",
              },
              {
                title: "Spiritual Therapy",
                desc: "Known to be the motherland of spiritualism, India offers spiritual therapies for inner healing.",
              },
              {
                title: "Food",
                desc: "Indian food is considered to be a bit on the spicy side, and often the food is often fried in oil or animal fat like butter or ghee.",
              },
              {
                title: "Shopping",
                desc: "Indian cities offering the best treatments also offer cultural shopping bazaars for tourists to indulge in.",
              },
              {
                title: "Entertainment",
                desc: "The Indian entertainment industry comprises standup comedy shows, theatres, movies and various experiential places.",
              },
            ].map((item, idx) => (
              <div
                key={idx}
                className="bg-gray-50 p-6 rounded-lg shadow hover:shadow-md transition"
              >
                <h5 className="text-xl font-semibold mb-3">{item.title}</h5>
                <p className="text-gray-600 mb-4">{item.desc}</p>
                <a
                  href="/festivals"
                  className="text-[#1976f2] inline-flex items-center"
                >
                  Learn More <i className="ri-arrow-right-line ml-1"></i>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* India Blogs Carousel */}
      <IndiaBlogsCarousel title="Latest Medical Tourism Insights for India" limit={6} />

      <section className="py-12">
        <div className="w-full flex justify-center px-4">
          <div className="w-full max-w-6xl bg-[#1976f2] rounded-xl shadow-lg p-8">
            <div className="flex flex-col md:flex-row items-center justify-between">
              <div className="md:w-2/3 mb-6 md:mb-0">
                <h4 className="text-white text-2xl md:text-3xl font-bold leading-snug">
                  Plan a relaxing treatment & <br /> stay tour in India today
                </h4>
              </div>

              <div className="md:w-1/3 text-center">
                <p className="text-white font-medium mb-3">
                  We charge <br /> 0% planning fee
                </p>
                <a
                  href="https://wa.me/9599222655"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center bg-white text-[#1976f2] font-semibold px-6 py-2 rounded-md hover:bg-gray-100 transition"
                >
                  <i className="ri-whatsapp-line mr-2"></i> Chat Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />

      {/* Callback Popup */}
      <CallbackPopup 
        isOpen={isCallbackOpen}
        onClose={() => setIsCallbackOpen(false)}
      />
      <FloatingChatButton />
    </div>
  );
};

export default IndiaMedicalPage;

// Components like Header, Footer, and ContactForm should be imported or defined separately.
